const menu = [
  {
    name: "Home",
    key: "home",
    icon: "HomeOutlined",
    path: "/",
  },
  {
    name: "Dashboard",
    key: "dashboard",
    icon: "EqualizerOutlined",
    path: "/dashboard",
  },
  {
    name: "Simulation",
    key: "simulation",
    icon: "SsidChartOutlined",
    path: "/simulation",
  },
  {
    name: "Material Base Price",
    key: "baseprice",
    icon: "AttachMoneyOutlined",
    path: "/base-price",
  },
  {
    name: "Exchange Rate",
    key: "exchange.rate",
    icon: "CurrencyExchangeOutlined",
    path: "/exchange-rate",
  },
  {
    name: "Return Scrap Price",
    key: "return.scrap",
    icon: "RecyclingOutlined",
    path: "/return-scrap",
  },
  {
    name: "First Tier Supplier",
    key: "breakdown",
    icon: "LocalShippingOutlined",
    path: "/breakdown",
  },
  {
    name: "Material Supplier",
    key: "material.supplier",
    icon: "LocalShippingOutlined",
    path: "/material-supplier",
  },
  {
    name: "Flagged Part",
    key: "flaggedpart",
    icon: "FlagOutlined",
    path: "/flagged-part",
  },
  {
    name: "PA Part",
    key: "pa.part",
    icon: "BuildOutlined",
    path: "/pa-part",
  },
  {
    name: "PA Supplier",
    key: "pa.supplier",
    icon: "BusinessOutlined",
    path: "/pa-supplier",
  },
  {
    name: "Material Master",
    key: "master.material",
    icon: "SettingsOutlined",
    path: "/master-material",
  },
  {
    name: "Process Master",
    key: "master.process",
    icon: "SettingsOutlined",
    path: "/master-process",
  },
  {
    name: "System Master",
    key: "master.system",
    icon: "SettingsOutlined",
    path: "/master-system",
  },
  {
    name: "Master Buyer Manager",
    key: "master.buyerboss",
    icon: "ManageAccountsOutlined",
    path: "/master-buyer-boss",
  },
  {
    name: "Master Part (Manual)",
    key: "master.manualpart",
    icon: "SettingsOutlined",
    path: "/master-manual-part",
  },
  {
    name: "Role Management",
    key: "role",
    icon: "PersonAddAltOutlined",
    path: "/master-role",
  },
  {
    name: "Log Activity",
    key: "log",
    icon: "HistoryOutlined",
    path: "/log",
  },
];

export default menu;
